import React from 'react' // eslint-disable-line no-unused-vars
import InputGroup from '../../forms/InputGroup'
import { submitForm, validateField } from '../../pages/functions'
import { api } from '../index.api'
import { formFieldsPerLanguage } from '../language/FormFieldsPerLanguage'
import { UncontrolledTooltip } from 'reactstrap'

class ProductLabelUpdate extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      edit: false,
      visible: !props.product.disabledForSelectedCountry,
      fields: {
        product: {
          name: 'product',
          value: props.product.name,
          rules: { title: 'Product', required: true }
        }
      }
    }

    this.lastUpdatedName = props.product.name
    formFieldsPerLanguage(this.state.fields, props.languageContent)
  }

  componentWillReceiveProps = nextProps => {
    this.setState({
      edit: false,
      visible: !nextProps.product.disabledForSelectedCountry,
      fields: {
        product: {
          name: 'product',
          value: nextProps.product.name,
          rules: { title: 'Product', required: true }
        }
      }
    })

    this.lastUpdatedName = nextProps.product.name
    formFieldsPerLanguage(this.state.fields, nextProps.languageContent)
  }

  _validate = (e, field) => {
    const fields = validateField(e, field, this.state.fields)
    this.setState({ fields })

    return false
  }

  handleEditClick = () => {
    this.setState({ edit: true })
  }

  handleCancelClick = () => {
    const { fields } = this.state
    fields.product.value = this.lastUpdatedName
    fields.product.errors = []
    this.setState({
      edit: false,
      fields
    })
  }

  handleToggleProductVisibility = () => {
    const localProduct = this._createProductLocalObject(!this.state.visible)

    api.admin.localProduct.updateProductName(localProduct,
      this._updateProductSuccessHandler.bind(this),
      this._updateProductFailureHandler.bind(this)
    )
  }

  handleSaveClick = e => {
    const fields = submitForm(e, this.state.fields)
    this.setState({ fields })

    for (const key in fields) {
      if (fields[key].errors.length > 0) {
        return false
      }
    }

    const localProduct = this._createProductLocalObject(this.state.visible)

    api.admin.localProduct.updateProductName(localProduct,
      this._updateProductSuccessHandler.bind(this),
      this._updateProductFailureHandler.bind(this)
    )
  }

  _updateProductSuccessHandler = response => {
    if (response.status === 200) {
      response.json().then(productLocal => {
        this.setState({ edit: false, visible: !productLocal.disable })
        this.lastUpdatedName = this.state.fields.product.value
      })
      this.props.notify('Success', 'Product updated successfully.', 'success')
    } else if (response.status === 401) {
      this.props.notify('Error',
        'You are not authorized to perform this action. Please log in again.',
        'error')
      setTimeout(() => window.location.replace('/'), 3000)
    } else {
      this.props.notify('Error', 'There seems to be some error while updating product.', 'error')
    }
  }

  _updateProductFailureHandler = (error) => { /* eslint-disable-line */
    this.props.notify('Error',
      'There seems to be an error at our server side. Please try later.',
      'error')
  }

  _createProductLocalObject = visible => {
    return {
      productCode: this.props.product.productCode,
      countryName: this.props.country,
      localName: this.state.fields.product.value,
      disable: !visible
    }
  }

  render () {
    const { product } = this.props

    return (
      <div className='product-local-update'>
        {this.state.edit
          ? (
            <div className='row'>
              <div className='col-9'>
                <InputGroup
                  field={this.state.fields.product}
                  validate={(e, field) => this._validate(e, this.state.fields.product)}
                />
              </div>
              <div className='col-3 input-group-actions p-l-0 p-r-0'>
                <span className='input-group-action m-r-5 save' onClick={this.handleSaveClick}>
                  <i className='sli-check' />
                </span>
                <span className='input-group-action cancel' onClick={this.handleCancelClick}>
                  <i className='sli-close' />
                </span>
              </div>
            </div>)
          : (
            <div>
              <span>{this.state.fields.product.value}</span>
              <span className='edit-product-icon' onClick={this.handleEditClick}>
                <i className='sli-pencil' />
              </span>
              <span
                id={product.productCode + '-product-visibility'}
                className='product-visibility-icon'
                onClick={this.handleToggleProductVisibility}
              >
                <i className={this.state.visible ? 'fa fa-icon fa-eye' : 'fa fa-icon fa-eye-slash'} />
              </span>
              <UncontrolledTooltip
                placement='right'
                target={product.productCode + '-product-visibility'}
              >
                {this.state.visible ? 'Hide Product' : 'Show Product'}
              </UncontrolledTooltip>
            </div>)}
      </div>
    )
  }
}

export default ProductLabelUpdate



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/ProductLabelUpdate.js